/* eslint-disable no-debugger */
/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable import/prefer-default-export */
import React from 'react';
import { translateDataSourceResultGroups } from '@progress/kendo-data-query';
import { debounce } from 'lodash';
import KendoService from '../../../services/logic/KendoService';
import LoadingPanel from './LoadingPanel';

export function withState(WrappedGrid, url, gridCustomizations) {
  return class StatefullGrid extends React.Component {
    constructor(props) {
      super(props);
      this.state = props.state || { dataState: { skip: 0, take: 50 }, loading: false };
    }

    componentDidMount() {
      this.fetchData(this.state.dataState);
    }

    handleDataStateChange = (changeEvent) => {
      this.setState({ dataState: changeEvent.dataState });
      this.fetchData(changeEvent.dataState);
    };

    async fetchData(dataState) {

      if (!url) {
        return; 
      }

      const hasGroups = typeof dataState.group !== 'undefined' && typeof dataState.group.length !== 'undefined';
      const isEdit = gridCustomizations?.editField;
    
      this.setState({ loading: true });
    
      const futureFilter = { filters: [], logic: 'and' };
      dataState.filter?.filters?.forEach((ef) => {
        // Due to magical circumstances on stage and production, “u” is substituted for the operator name instead of
        // the proper “inRange”. Most likely this is a bug in the Kendo React library and the check below is needed to
        // eliminate this unpredictable behavior
        if (ef.operator?.name === 'inRange' || ef.operator?.name === 'u') {
          if (ef.value.min) {
            futureFilter.filters.push({
              field: ef.field,
              value: new Date(ef.value.min).toISOString(),
              operator: 'gte',
            });
          }
          if (ef.value.max) {
            futureFilter.filters.push({
              field: ef.field,
              value: new Date(ef.value.max).toISOString(),
              operator: 'lte',
            });
          }
        } else {
          futureFilter.filters.push(ef);
        }
      });
    
      const newDatastate = { ...dataState, filter: futureFilter };
      const json = await KendoService.makeTheCall(url, newDatastate);
      this.setState({ loading: false });
    
      if (json) {
        const resData = hasGroups ? translateDataSourceResultGroups(json.data) : json.data;
        const data = isEdit ? resData.data.map((item) => ({ ...item, inEdit: true })) : resData.data;
    
        this.setState({
          data,
          total: resData.total,
        });
      }
    }

    debouncedFetchData = debounce((dataState) => {
      this.fetchData(dataState || this.state.dataState); 
    }, 1000);

    handleFilterChange = (event) => {
      const newDataState = {
        ...this.state.dataState,
        filter: event.filter,
      };
      this.setState({ dataState: newDataState });
      this.debouncedFetchData(newDataState);
    };

    externalFilterChange = (values) => {
      this.setState((prevState) => ({
        dataState: KendoService.mergeFilters(prevState.dataState, values),
      }));
      this.debouncedFetchData();
    };

    updateOneRow = (row) => {
      var newData = [];
      this.state.data.forEach((element) => {
        if (element.id !== row.id) {
          newData.push(element);
        } else {
          newData.push(row);
        }
      });
      this.setState({
        data: newData,
      });
    };

    update = (dataState) => {
      this.fetchData(!!dataState ? dataState : this.state.dataState);
    };

    render() {
      return (
        <>
          <WrappedGrid
            update={this.update}
            filterable
            onFilterChange={this.handleFilterChange}
            sortable
            pageable={{ pageSizes: true }}
            {...this.props}
            total={this.state.total}
            data={this.state.data}
            skip={this.state.dataState.skip}
            take={this.state.dataState.take}
            filter={this.state.dataState.filter}
            sort={this.state.dataState.sort}
            onDataStateChange={this.handleDataStateChange}
            {...gridCustomizations}
            pageSize={0}
          />

          {this.state.loading && <LoadingPanel />}
        </>
      );
    }
  };
}
